import Vue from 'vue'
import App from './App.vue'
import router from './router'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import VueMoment from 'vue-moment'

const moment = require('moment')
require('moment/locale/es')

const firebaseConfig = {
  apiKey: "AIzaSyCrYN0NI1vhHLlYffHhJeEP3NMPJ75Rvco",
  authDomain: "cayros-school.firebaseapp.com",
  databaseURL: "https://cayros-school.firebaseio.com",
  projectId: "cayros-school",
  storageBucket: "cayros-school.appspot.com",
  messagingSenderId: "570771330807",
  appId: "1:570771330807:web:b76e7146b59e555570a5f2"
}
// Initialize Firebase
firebase.initializeApp(firebaseConfig)

export const firestore = firebase.firestore()
export const storage = firebase.storage()

Vue.config.productionTip = false

Vue.use(VueMoment, {
  moment
})

let app = null
firebase.auth().onAuthStateChanged(()=> {
  if (!app) {
    app = new Vue({
      router,
      render: h => h(App)
    }).$mount('#app')
  }
})